import LiveCodingEditor from './LiveCodingEditor';

export default LiveCodingEditor;
